// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   WHOLESALE DEALER VIEW COMPONENT STYLES
   ============================================ */

body {
	color: #495057;
}

a {
	color: #27405f;
	text-decoration: none;
}

a:hover {
	color: #1d3049;
	text-decoration: underline;
}

/* ============================================
   BUTTON STYLES
   ============================================ */
.btn-primary {
	background-color: #27405f;
	border: 1px solid #27405f;
	font-weight: 600;
	color: white;
	text-align: center;
	height: 40px;
	padding: 0.5rem 1.5rem;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s, border-color 0.2s;
}

.btn-primary:hover {
	background-color: #1d3049;
	border-color: #1d3049;
}

/* ============================================
   TABLE STYLES
   ============================================ */
.responsive-table {
	width: 100%;
	margin-bottom: 1.5em;
	border-spacing: 0;
	font-size: 0.9em;
}

th {
	background-color: #27405f;
	border: 1px solid #27405f;
	font-weight: 600;
	text-align: center;
	color: white;
	padding: 0.75rem;
}

td {
	background-color: #ffffff;
	border: 1px solid #e9ecef;
	color: #495057;
	text-align: left;
	padding: 0.5rem;
}

/* ============================================
   FORM LAYOUT STYLES
   ============================================ */
.select2-drop {
	width: 10%;
}

.commitButtonPadding {
	padding-top: 15px;
	float: right;
	padding-right: 25px;
}

/* ============================================
   ALIGNMENT UTILITIES
   ============================================ */
.center-right-alignment {
	width: 100px;
	margin-left: auto;
	margin-right: auto;
	padding-right: 35px;
}

.right-align {
	text-align: right;
}

.color-font-size-align {
	background-color: white;
	font-size: small;
}

.bold-align {
	font-weight: bold;
}

.left-align {
	text-align: left;
}

.center-align {
	text-align: center;
}

/* ============================================
   COPY BUTTON STYLES
   ============================================ */
.copy-button {
	padding: 0.25rem 0.5rem !important;
	font-family: "Trebuchet MS", Arial, Helvetica, sans-serif !important;
	font-weight: bold !important;
	background: #27405f !important;
	color: white !important;
	border: none !important;
	border-radius: 4px !important;
	cursor: pointer !important;
	margin-left: 0.5rem !important;
	font-size: 0.875rem !important;
}

.copy-button:hover {
	box-shadow: 2px 2px 0px #0F3771 !important;
	background: #2399e5 !important;
}

/* ============================================
   PRIMENG TABLE OVERRIDES
   ============================================ */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
	background: #27405f !important;
	color: white !important;
	border: 1px solid #27405f !important;
	font-weight: 600 !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
	border: 1px solid #e9ecef !important;
	background: #ffffff !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover > td {
	background: #f8f9fa !important;
}

/* PrimeNG 19 checkbox checked state */
:host ::ng-deep .p-checkbox-checked .p-checkbox-box {
	border-color: #27405f !important;
	background: #27405f !important;
}

:host ::ng-deep .p-checkbox-checked .p-checkbox-icon {
	color: #ffffff !important;
}

:host ::ng-deep .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
	border-color: #1d3049 !important;
	background: #1d3049 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/wholesale-dealer-view/wholesale-dealer-view.component.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;;iDAEiD;AACjD;CACC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,oDAAoD;AACrD;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;iDAEiD;AACjD;CACC,WAAW;CACX,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;iDAEiD;AACjD;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;;iDAEiD;AACjD;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;iDAEiD;AACjD;CACC,kCAAkC;CAClC,oEAAoE;CACpE,4BAA4B;CAC5B,8BAA8B;CAC9B,uBAAuB;CACvB,uBAAuB;CACvB,6BAA6B;CAC7B,0BAA0B;CAC1B,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,0CAA0C;CAC1C,8BAA8B;AAC/B;;AAEA;;iDAEiD;AACjD;CACC,8BAA8B;CAC9B,uBAAuB;CACvB,oCAAoC;CACpC,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,sCAAsC;AACtC;CACC,gCAAgC;CAChC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,8BAA8B;AAC/B","sourcesContent":["/* ============================================\n   WHOLESALE DEALER VIEW COMPONENT STYLES\n   ============================================ */\n\nbody {\n\tcolor: #495057;\n}\n\na {\n\tcolor: #27405f;\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: #1d3049;\n\ttext-decoration: underline;\n}\n\n/* ============================================\n   BUTTON STYLES\n   ============================================ */\n.btn-primary {\n\tbackground-color: #27405f;\n\tborder: 1px solid #27405f;\n\tfont-weight: 600;\n\tcolor: white;\n\ttext-align: center;\n\theight: 40px;\n\tpadding: 0.5rem 1.5rem;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s, border-color 0.2s;\n}\n\n.btn-primary:hover {\n\tbackground-color: #1d3049;\n\tborder-color: #1d3049;\n}\n\n/* ============================================\n   TABLE STYLES\n   ============================================ */\n.responsive-table {\n\twidth: 100%;\n\tmargin-bottom: 1.5em;\n\tborder-spacing: 0;\n\tfont-size: 0.9em;\n}\n\nth {\n\tbackground-color: #27405f;\n\tborder: 1px solid #27405f;\n\tfont-weight: 600;\n\ttext-align: center;\n\tcolor: white;\n\tpadding: 0.75rem;\n}\n\ntd {\n\tbackground-color: #ffffff;\n\tborder: 1px solid #e9ecef;\n\tcolor: #495057;\n\ttext-align: left;\n\tpadding: 0.5rem;\n}\n\n/* ============================================\n   FORM LAYOUT STYLES\n   ============================================ */\n.select2-drop {\n\twidth: 10%;\n}\n\n.commitButtonPadding {\n\tpadding-top: 15px;\n\tfloat: right;\n\tpadding-right: 25px;\n}\n\n/* ============================================\n   ALIGNMENT UTILITIES\n   ============================================ */\n.center-right-alignment {\n\twidth: 100px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tpadding-right: 35px;\n}\n\n.right-align {\n\ttext-align: right;\n}\n\n.color-font-size-align {\n\tbackground-color: white;\n\tfont-size: small;\n}\n\n.bold-align {\n\tfont-weight: bold;\n}\n\n.left-align {\n\ttext-align: left;\n}\n\n.center-align {\n\ttext-align: center;\n}\n\n/* ============================================\n   COPY BUTTON STYLES\n   ============================================ */\n.copy-button {\n\tpadding: 0.25rem 0.5rem !important;\n\tfont-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif !important;\n\tfont-weight: bold !important;\n\tbackground: #27405f !important;\n\tcolor: white !important;\n\tborder: none !important;\n\tborder-radius: 4px !important;\n\tcursor: pointer !important;\n\tmargin-left: 0.5rem !important;\n\tfont-size: 0.875rem !important;\n}\n\n.copy-button:hover {\n\tbox-shadow: 2px 2px 0px #0F3771 !important;\n\tbackground: #2399e5 !important;\n}\n\n/* ============================================\n   PRIMENG TABLE OVERRIDES\n   ============================================ */\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n\tbackground: #27405f !important;\n\tcolor: white !important;\n\tborder: 1px solid #27405f !important;\n\tfont-weight: 600 !important;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\n\tborder: 1px solid #e9ecef !important;\n\tbackground: #ffffff !important;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover > td {\n\tbackground: #f8f9fa !important;\n}\n\n/* PrimeNG 19 checkbox checked state */\n:host ::ng-deep .p-checkbox-checked .p-checkbox-box {\n\tborder-color: #27405f !important;\n\tbackground: #27405f !important;\n}\n\n:host ::ng-deep .p-checkbox-checked .p-checkbox-icon {\n\tcolor: #ffffff !important;\n}\n\n:host ::ng-deep .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {\n\tborder-color: #1d3049 !important;\n\tbackground: #1d3049 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
